import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useHeader } from '@/hooks/useHeader'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import ArchiveKnowledgeDatatableView from '@/components/UI/KnowledgeDatatableComponent/ArchiveKnowledgeDatatableView'

const ArchivedKnowledge = (props: any) => {
  const { t } = useTranslation('translation')
  const { setHeaderText } = useHeader()

  useEffect(() => {
    setHeaderText('Knowledge')
  }, [setHeaderText])

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader title={t('Archived Knowledge')} />
      <ArchiveKnowledgeDatatableView />
    </section>
  )
}

export default ArchivedKnowledge
